import { ready } from './utils-child';
import { locationModal } from './location-modal-window';
import { setsTabs } from './sets-tabs';
import { counterAnimation } from './animation';
import { lightbox } from './lightbox';
import { openFirstAccordion } from './accordions-pre-open';
require('fslightbox');

ready(() => {
  // locationModal();
  setsTabs();
  counterAnimation();
  lightbox();
  openFirstAccordion();
});
